import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  onSubmit?: () => void;
  submitText?: string;
  cancelText?: string;
  isSubmitting?: boolean;
  submittingText?: React.ReactNode;
}

const FormDialog: React.FC<FormDialogProps> = ({
  open,
  onClose,
  title,
  children,
  onSubmit,
  submitText = "Submit",
  cancelText = "Cancel",
  isSubmitting = false,
  submittingText = "Submitting...",
}) => {
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down("sm")); // Matches small screens

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      maxWidth="md"
      fullWidth
      fullScreen={isFullScreen}
      classes={{
        paper: "rounded-lg",
      }}
      style={{
        cursor: isSubmitting ? "wait !important" : "default",
      }}
    >
      {title && (
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            display: "flex",
            fontWeight: "bold",
            bgcolor: "primary.main",
            color: "white",
            padding: 2,
          }}
        >
          {title}
        </DialogTitle>
      )}

      <DialogContent className="mt-2">{children}</DialogContent>
      <DialogActions className="flex justify-between p-4">
        <Button
          onClick={onClose}
          disabled={isSubmitting}
          className="text-gray-500 hover:bg-gray-100"
          variant="outlined"
        >
          {cancelText}
        </Button>
        {onSubmit && (
          <Button
            onClick={onSubmit}
            variant="contained"
            disabled={isSubmitting}
          >
            {isSubmitting ? submittingText : submitText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default FormDialog;
